import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  existingApprovalIds: [],
  showIamInterestedModal: false,
  currentItem: "",
  disableIamInterestedButton: false,
  apiRequestLoading: false,
  hideCancelButton: false,
  apiRequestTriggered: false,
  iamInterestedModalTitle:
    "Are you sure want to continue? This will create the interest in this course and line managers must approve your request",
};

export const userItemApprovalSlice = createSlice({
  name: "userItemApproval",
  initialState,
  reducers: {
    setUserItemApprovalData: (state, action) => {
      // console.log(state,"state")
      // Redux Toolkit allows us to write "mutating" logic in reducers. It
      // doesn't actually mutate the state because it uses the Immer library,
      // which detects changes to a "draft state" and produces a brand new
      // immutable state based off those changes
      for (let x in action.payload) {
        if (x in state) {
          state[x] = action.payload[x];
        }
      }
    },
    resetUserItemApprovalData: () => {
      return initialState;
    },
  },
});

// Action creators are generated for each case reducer function
export const { setUserItemApprovalData, resetUserItemApprovalData } =
  userItemApprovalSlice.actions;

export default userItemApprovalSlice.reducer;
